<template>
  <div>
    <select v-model="selected" class="selector">
      <option v-for="zone in zones" :key="zone.id" class="test" :value="zone.value">
        {{ zone.text }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ZoneSelectTable',
  props: {
    globalZone: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      zones: [],
      selected: localStorage.getItem('siteId')
    };
  },
  computed: {
    ...mapGetters('site', ['listPermission', 'sites'])
  },
  watch: {
    selected(newValue) {
      this.setSelectedZoneForAccount(newValue);
      if (this.globalZone) {
        localStorage.setItem('siteId', newValue);
        window.location.reload();
      }
    }
  },
  async mounted() {
    await this.fetchSites();
    await this.getListToPermission();
    this.generateSitesList();
    await this.setSelectedZoneForAccount(localStorage.getItem('siteId'));
  },
  methods: {
    ...mapActions('site', ['fetchSites', 'setSelectedZoneForAccount', 'getListToPermission']),

    generateSitesList() {
      // C'est la liste qui est dans le header => on utilise les permissions actuelles de l'utilisateur pour générer la liste des sites
      if (this.globalZone) {
        this.zones = this.listPermission.map(site => ({ id: site.id, text: `Zone ${site.name}`, value: site.id }));
        localStorage.setItem('siteId', this.selected);
      } else {
        // C'est la liste qui est dans le panel admin pour ajouter les permissions/rôles => on utilise la liste complète des sites
        this.zones = this.sites.map(site => ({ id: site.id, text: site.name, value: site.id }));
      }
    }
  }
};
</script>

<style lang="scss">
.selector {
  appearance: auto;
  margin: 0.5rem;
  padding: 0.5rem !important;
  border: 1px solid #3f3f44;
  border-radius: 1rem;
}
</style>
